<!-- Оборачивает форму создания категории расходов в базовую модалку -->
<template>
  <BaseModal
    :visible="true"
    title="Создание категории расходов"
    size="md"
    @close="$emit('close')"
  >
    <ExpenseCategoryForm
      :is-loading="isSubmitting"
      submit-label="Создать"
      @save="handleSave"
      @cancel="$emit('close')"
    />
  </BaseModal>
</template>

<script>
import { useNotificationStore } from "@/stores/notificationStore";
import { useExpenseCategoryStore } from "@/stores/expenseCategoryStore";

import ExpenseCategoryForm from "@/components/Expense/ExpenseCategoryForm.vue";

export default {
  name: "AddCategoryModal",
  components: { ExpenseCategoryForm },
  props: {
    companyId: {
      type: Number,
      required: true,
    },
  },
  emits: ["close", "categories-created"],
  data() {
    return {
      isSubmitting: false,
    };
  },
  computed: {
    notificationStore() {
      return useNotificationStore();
    },
  },
  methods: {
    async handleSave(payload) {
      try {
        this.isSubmitting = true;
        const store = useExpenseCategoryStore();
        const category = await store.createExpenseCategory(payload);
        this.notificationStore.showSuccess("Категория создана");
        this.$emit("categories-created", category);
        this.$emit("close");
      } catch {
        // ошибка обрабатывается в сторе
      } finally {
        this.isSubmitting = false;
      }
    },
  },
};
</script>
